<!-- - DEFAULT-->
<div
  class="event-log-box"
  [id]="'log-box-' + log.id"
  [class.is-select]="log.isSelected"
  [class.is-warning]="parseWarningLog()"
  (mouseenter)="onHoverLog($event, log.id)"
  (mouseleave)="onMouseLeaveLog($event, log)"
>
  <div class="event-log-action-box">
    <div class="action-box default" [ngClass]="isAutomationRule() ? 'automation' : 'default'">
      <div class="loader absolute log-loader" *ngIf="log.isLoading">
        <svg class="circular" viewBox="25 25 50 50">
          <circle
            class="path log-stroke-color"
            cx="50"
            cy="50"
            r="20"
            fill="none"
            stroke-width="4"
            stroke-miterlimit="10"
          ></circle>
        </svg>
      </div>
      <div class="v-center">
        <i
          class="material-icons"
          *ngIf="logIcon.type === 'material'"
          [style.color]="computedIconColor(log)"
          [style.font-size]="computedIconSize(log) + 'px'"
          style="font-size: 32px"
          >{{ logIcon.name }}</i
        >
        <comp-icon
          *ngIf="logIcon.type === 'comp'"
          [icon]="logIcon.name"
          [color]="computedIconColor(log)"
          [size]="computedIconSize()"
        ></comp-icon>
      </div>
    </div>
  </div>
  <div class="event-log-metadata">
    <div class="flex" style="gap: 6px; flex-direction: column">
      <div class="v-center" style="gap: 8px; flex-wrap: wrap">
        <div class="event-log-metadata-time">{{ log.eventCreated }}</div>
        <div class="event-log-metadata-category v-center" style="gap: 8px; flex-wrap: wrap">
          <div>{{ log.category }}</div>
          <div class="badge automation" *ngIf="isAutomationRule()" style="margin-left: 4px">Automation Action</div>
          <div
            class="--g-tooltip-content"
            *ngIf="parseWarningLog()"
            (mouseenter)="commonService.setTooltipPosition($event, 'top-center')"
          >
            <comp-icon class="--g-tooltip-icon" [icon]="'info'" [size]="16" [color]="'rgb(205, 61, 100)'"></comp-icon>
            <div class="--g-tooltip" style="text-transform: none">
              This event includes data that could not be transmitted to the monitoring station.
            </div>
          </div>
        </div>
      </div>
      <div class="v-center" style="gap: 8px; flex-wrap: wrap">
        <ng-container *ngFor="let list of log.eventCodeList">
          <div
            class="--g-tooltip-content"
            (mouseenter)="commonService.setTooltipPosition($event, 'top-center')"
            style="margin: 0"
          >
            <div class="badge xml-code">{{ list.code }}</div>
            <div class="--g-tooltip tooltip-background">XML Code</div>
          </div>
        </ng-container>
      </div>
      <div class="event-log-metadata-device">
        <div
          class="--g-tooltip-content"
          *ngIf="log.zone_number"
          (mouseenter)="commonService.setTooltipPosition($event, 'top-center')"
          style="margin: 0"
        >
          <div class="event-log-metadata-device-zone">{{ log.zone_number }}</div>
          <div class="--g-tooltip tooltip-background">Device ID</div>
        </div>
        <div class="event-log-metadata-device-name" [class.no-name]="!log.name">{{ log.name ?? "No Name" }}</div>
      </div>
      <div class="event-log-metadata-other" *ngIf="log.trigger.toLowerCase() != 'procedure'">
        {{ log.trigger }} - {{ log.status_text }}
      </div>
      <div class="event-log-metadata-other" *ngIf="log.trigger.toLowerCase() === 'procedure'">
        {{ procedureName ?? " No Procedure Name" }}
      </div>
      <div class="event-log-metadata-other" *ngIf="log?.partnerDescription">{{ log?.partnerDescription }}</div>
    </div>
    <div class="event-log-metadata-id">
      <span *ngIf="log?.event_id">ID {{ log.event_id }}</span>
      <span *ngIf="log?.partnerEventId"> | Partner ID {{ log.partnerEventId }}</span>
    </div>
    <!-- SLOT : toolbar-->
    <ng-container *ngTemplateOutlet="toolbar; context: { log: log }"></ng-container>
  </div>
</div>
